import { gql } from "@apollo/client";

// GraphQL query for reviews
export const GET_REVIEWS_QUERY = gql`
	query GetReviews($params: ReviewsInputParam) {
		reviews(params: $params) {
			get {
				rating
				count
				data {
					review
					rating
					reviewer {
						displayName
						profilePhotoUrl
					}
					summary
					createdAt
				}
			}
		}
	}
`;

// TypeScript interfaces
interface ReviewerInfo {
	displayName?: string;
	profilePhotoUrl?: string;
}

export interface ReviewData {
	review: string;
	rating: number;
	reviewer?: ReviewerInfo;
	summary?: string;
	createdAt?: string;
}
